import { render, staticRenderFns } from "./warehouse-icon.vue?vue&type=template&id=20d38410&scoped=true"
import script from "./warehouse-icon.vue?vue&type=script&lang=js"
export * from "./warehouse-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d38410",
  null
  
)

export default component.exports